import {GoogleAnalyticsService} from '../../service/utils/google-analytics.service';
import {WindowService} from '../../service/window/window.service';
import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.scss']
})
export class LinksComponent implements OnInit {

  constructor(
    private _windowServ: WindowService,
    private _gaServ: GoogleAnalyticsService) {
  }

  ngOnInit() {
    this._windowServ.scrollTop();
  }

  public onClickExternalLink(event: Event, targetName: string): void {
    this._gaServ.sendLinkClickEvent('links-page', targetName);
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/pages/links/links.component.ts